/* 
 * Filename:     
 * Website:      
 * Description:  
 * Author:       
 * */

/*
|--------------------------------------------------------------------------
| Modules
|--------------------------------------------------------------------------
|
|
 */
import 'angular-animate'
import './Modules/ng-validation'
import 'angular-messages'
import 'angular-loading-overlay'

var app = angular.module("eshopApp", ["ngAnimate", "ngValidate", "ngMessages", "bsLoadingOverlay"]);

/*
|--------------------------------------------------------------------------
| App Configuration
|--------------------------------------------------------------------------
|
|
 */
app.config(function ($interpolateProvider, $validatorProvider) {
    $interpolateProvider.startSymbol("{{");
    $interpolateProvider.endSymbol("}}");

    $validatorProvider.addMethod("regex", function (value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    }, "Please check your input.");
});

/*
|--------------------------------------------------------------------------
| App Run
|--------------------------------------------------------------------------
|
|
 */
app.run(["$http", "$rootScope", "$timeout", "bsLoadingOverlayService", "$compile", function ($http, $rootScope, $timeout, bsLoadingOverlayService, $compile) {

    //Define on header that request comes from ajax
    $http.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

    $rootScope.params = function (params) {
        params._token = window.Laravel.csrfToken;
        return $.param(params);
    }
    
    $rootScope.path = window.location.pathname;

    bsLoadingOverlayService.setGlobalConfig({
        delay: 500,
        templateUrl: '/helpers/get/loader'
    });

    $rootScope.showOverlay = function (referenceId) {
        bsLoadingOverlayService.start({
            referenceId: referenceId
        });
    };

    $rootScope.hideOverlay = function (referenceId) {
        $timeout(bsLoadingOverlayService.stop({
            referenceId: referenceId
        }), 1000);
    }

    $rootScope.wishlist = [];

    $rootScope.fancyboxInlineOptions = {
        toolbar: false,
        smallBtn: true,
        trapFocus: false,
        touch: false,
        clickOutside: false,
        btnTpl: {
            arrowLeft: `
            <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
                <i class="icon-arrow-left"></i>
            </button>
            `,
            arrowRight: `
            <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
                <i class="icon-arrow-right"></i>
            </button>
            `,
            smallBtn: `
            <button data-fancybox-close class="fancybox-button fancybox-close-small">
                <i class="icon-close icon-m"></i>
            </button>
            `,
        },
        beforeLoad: function (instance, slide) {
            if (slide.$slide[0].attributes["data-fancybox-class"]) {
                $(instance.$refs.container[0]).addClass(
                    instance.$lastFocus[0].attributes["data-fancybox-class"].value
                );
            }
        },
        afterClose: function () {
            try {
                $scope.responses.registerForm.success = false;
            } catch (e) {

            }
        }
    };

    $rootScope.getsession = function () {
        $http({
            method: "GET",
            url: "/account/getsession",
            data: $rootScope.params([]),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function success(successResponse) {
            $rootScope.session = successResponse.data;
        }, function error(errorResonse) {
            $rootScope.session_error = errorResonse.data;

        });
    };

    $rootScope.getController = function (controller) {
        return angular.element('[ng-controller="' + controller + '"]').scope();
    }

    $rootScope.$data = {};
}]);

/*
|--------------------------------------------------------------------------
| Controllers
|--------------------------------------------------------------------------
|
|
 */

import accountCtrl from './Controllers/01.account.ctrl';
app.controller('accountCtrl', accountCtrl);

import accountshippingCtrl from './Controllers/02.account.shipping.ctrl';
app.controller('accountshippingCtrl', accountshippingCtrl);

import accountWishlistCtrl from './Controllers/03.account.wishlist.ctrl';
app.controller('accountWishlistCtrl', accountWishlistCtrl);

import cartCtrl from './Controllers/04.cart.ctrl';
app.controller('cartCtrl', cartCtrl);

import checkoutCtrl from './Controllers/05.checkout.ctrl';
app.controller('checkoutCtrl', checkoutCtrl);

import checkoutDeliveryDetailsCtrl from './Controllers/06.checkout.delivery.details.ctrl';
app.controller('checkoutDeliveryDetailsCtrl', checkoutDeliveryDetailsCtrl);

import checkoutOrderDetailsCtrl from './Controllers/07.checkout.order.details.ctrl';
app.controller('checkoutOrderDetailsCtrl', checkoutOrderDetailsCtrl);

import productListCtrl from './Controllers/08.products.list.ctrl';
app.controller('productListCtrl', productListCtrl);

import productInnerCtrl from './Controllers/09.products.inner.ctrl';
app.controller('productInnerCtrl', productInnerCtrl);

import mapController from './Controllers/10.map.ctrl';
app.controller('mapController', mapController);

import mobileMenuCtrl from './Controllers/11.mobile.menu.ctrl';
app.controller('mobileMenuCtrl', mobileMenuCtrl);

import newsletterCtrl from './Controllers/12.newsletter.ctrl';
app.controller('newsletterCtrl', newsletterCtrl);

import talkToUsCtrl from './Controllers/13.talkToUs.ctrl';
app.controller('talkToUsCtrl', talkToUsCtrl);

import DropHintCtrl from './Controllers/14.drophint.ctrl';
app.controller('DropHintCtrl', DropHintCtrl);

/*
|--------------------------------------------------------------------------
| App Filters
|--------------------------------------------------------------------------
|
|
 */
import brackets from './Filters/brackets'
app.filter('brackets', brackets);

import page from './Filters/page'
app.filter('page', page);

// import stokoiFilter from './Filters/stokoi-filter'
// app.filter("stokoiFilter", stokoiFilter);

/*
|--------------------------------------------------------------------------
| App Directives
|--------------------------------------------------------------------------
|
|
 */

import focusOnError from './Directives/focus-on-error';
app.directive("focusOnError", focusOnError)

import scrollToError from './Directives/scroll-to-error';
app.directive("scrollToError", scrollToError)

import onRepeatEnd from './Directives/on-repeat-end';
app.directive("onRepeatEnd", onRepeatEnd);

import toNumbers from './Directives/to-numbers';
app.directive('toNumbers', toNumbers);

import stringToNumber from './Directives/string-to-number';
app.directive("stringToNumber", stringToNumber);

import convertToNumber from './Directives/convert-to-number';
app.directive("convertToNumber", convertToNumber);

/*
|--------------------------------------------------------------------------
| $ On Document Ready
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
$(function () {
    /**
     * CART
     */
    initCart();
});

function alterGETparam(param, value) {
    var newURL = updateURLParameter(window.location.href, param, value);
    newURL = updateURLParameter(newURL, param, value);
    window.history.replaceState('', '', updateURLParameter(window.location.href, param, value));
}

function updateURLParameter(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
        if (TheAnchor)
            additionalURL = TheParams;

        tempArray = additionalURL.split("&");

        for (var i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    } else {
        var tmpAnchor = baseURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];

        if (TheParams)
            baseURL = TheParams;
    }

    if (TheAnchor)
        paramVal += "#" + TheAnchor;

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}

/*
|--------------------------------------------------------------------------
| CART
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
function initCart() {

    $("#cart .managequantity").on("click", function (e) {
        //debugger;
        var q = $(this).data("quantity");
        var curVal = $(this)
            .siblings(".cart-prod-quantity")
            .text();
        var val = 0;

        if (q == "decrease") {
            val = -1;
        } else if (q == "increase") {
            val = 1;
        } else {
            val = 0;
        }

        if (parseInt(curVal) == 1 && q == "decrease") {
            val = 0;
        }

        e.preventDefault();
        if (!$(this).hasClass("disabled")) manageQuantity($(this), val);

    });

    $("#cart").delegate(".quantity-cart", "blur", function () {
        var available = $(this)
            .closest(".bag-item")
            .data("available");
        var currentqty = parseInt($(this).data("currentqty"));
        var newqty = parseInt($(this).val());

        if (isNaN(newqty)) {
            $(this).val(currentqty);
        } else {
            if (currentqty != newqty) {
                if (newqty > available) {
                    $(this).val(available);
                } else if (newqty <= 0) {
                    $(this).val(1);
                }
                var newqty = parseInt($(this).val());
                if (currentqty != newqty) {
                    manageQuantity($(this), newqty - currentqty);
                }
            }
        }
    });

    $("#cart .add-to-wishlist").click(function (e) {
        e.preventDefault();
        //var variant = $(".variant-filter button.active").data('variantid');
        var variant = $(this).data("variant");
        var notification = $(this).data("notification");
        var thisObj = $(this).parent();

        if (typeof variant == "undefined") {
            displayMessageCart("selectSize", true, thisObj);
        } else {
            var jsonData = {
                action: "addtowishlist",
                variantid: variant
            };
            if (notification) {
                jsonData.notification = 1;
            }

            // $.ajax({
            //     url: "/actions.php",
            //     data: jsonData,
            //     dataType: "json",
            //     success: function (result) {

            //         if (notification && result.success >= 0) {
            //             displayTimedMessageCart("notifySuccess", 6000, thisObj);
            //         } else {
            //             if (result.success > 0) {
            //                 displayTimedMessageCart("addedToWishlist", 6000, thisObj);
            //             } else if (result.success == 0) {
            //                 displayTimedMessageCart("alreadyInWishlist", 6000, thisObj);
            //             } else if (result.success == -1) {
            //                 displayTimedMessageCart("notLoggedIn", 6000, thisObj);
            //             }
            //         }
            //     }
            // });
        }
    });

    $(".removeFromCart").click(function (e) {
        e.preventDefault();
        manageQuantity($(this), 0);
    });

    $(".summaries").delegate(".checkout.disabled", "click", function () {
        displayMessage("wholesaleMinimum", true);
    });
}

function toggleTopCallback() {
    // $.get('/ajax/cart.php?raw=1', function (data) {
    //     $('#cart .loadingContent').fadeOut(function () {
    //         $('#cart .loadedContent').html(data).fadeIn();
    //         initCart();
    //     })
    // });
}

function manageQuantity(elem, addqty) {
    var oiid = $(elem)
        .closest("tr")
        .data("oiid");
    // $.ajax({
    //     url: "/actions.php",
    //     data: {
    //         action: "managequantity",
    //         oiid: oiid,
    //         addqty: addqty
    //     },
    //     dataType: "json",
    //     success: function (result) {
    //         parseBasketValues(result);
    //         itemAdditionCallback(result, addqty, oiid);
    //         $rootScope = angular.element('body').scope().$root
    //         $rootScope.getsession();
    //         $rootScope.$apply();
    //     }
    // });
}

function itemAdditionCallback(result, addqty, oiid) {
    var currentQty = parseInt(
        $("#cart tr[data-oiid='" + oiid + "'] .cart-prod-quantity").text()
    );
    var newQty = currentQty + addqty;
    var listItem = $("#cart tr[data-oiid='" + oiid + "']");

    $(listItem)
        .find(".cart-prod-quantity")
        .text(newQty);

    if (result.item_price !== false)
        $(listItem)
        .find(".itemPrice")
        .text(result.item_price);

    if (addqty == 0) {
        //debugger;
        $(listItem).fadeOut("fast", function () {
            $(this).remove();
            if ($("#cart .table-cart.cart-items tr").length < 1) {
                $("#cart #withItems").fadeOut("fast", function () {
                    $("#noItems").fadeIn("fast");
                });
            }
        });
    } else {
        var qty = $(listItem)
            .find(".quantity-cart")
            .val();

        if (qty >= $(listItem).data("available")) {
            $(listItem)
                .find(".addQty")
                .addClass("disabled");
        } else {
            $(listItem)
                .find(".addQty")
                .removeClass("disabled");
        }
        if (qty <= 1) {
            $(listItem)
                .find(".removeQty")
                .addClass("disabled");
        } else {
            $(listItem)
                .find(".removeQty")
                .removeClass("disabled");
        }
    }
    if (result.checkout_enabled) {
        displayMessage("wholesaleMinimum", false);
        $(".checkout").removeClass("disabled");
    } else {
        displayMessage("wholesaleMinimum", true);
        $(".checkout").addClass("disabled");
    }
    showLastItems();

    if (typeof result.items != "undefined") {
        //$(".btn-cart.total-product-quantity span").text(result.items);
    } else {
        //$(".btn-cart.total-product-quantity span").text(result.total_items);
    }

    toggleTopCallback();
}

function submitCallback() {
    parent.location.reload();
}

function showLastItems() {
    //$("#cart tbody tr").each(function () {
    $("#cart .bag-item").each(function () {
        if ($(this).data("available") == $(this).find(".quantity-cart").val()) {
            $(this).find(".lastItem:hidden").fadeIn("fast");
        } else {
            $(this).find(".lastItem:visible").fadeOut("fast");
        }
    });
}

function displayTimedMessageCart(msgNumber, time, context) {
    displayMessageCart(msgNumber, true, context);
    setTimeout(function () {
        displayMessageCart(msgNumber, false, context);
    }, time);
}

function displayMessageCart(msgNumber, showError, context) {
    var elem = context.find(" .msg-" + msgNumber);
    if (showError) {
        if (elem.is(":hidden")) {
            elem.fadeIn("fast");
        } else {
            animateElement(elem);
        }
    } else {
        elem.fadeOut("fast");
    }
}

function displayTimedMessage(msgNumber, time) {
    displayMessage(msgNumber, true);
    setTimeout(function () {
        displayMessage(msgNumber, false);
    }, time);
}

function displayMessage(msgNumber, showError) {
    var elem = $(".msg-" + msgNumber);
    if (showError) {
        if (elem.is(":hidden")) {
            elem.fadeIn("fast");
        } else {
            animateElement(elem);
        }
    } else {
        elem.fadeOut("fast");
    }
}

function animateElement(elem) {
    var animationStyle = "animated shake";
    var animationEnd =
        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
    elem.addClass(animationStyle).one(animationEnd, function () {
        $(this).removeClass(animationStyle);
    });
}

function adjustRegions(container, cid) {

    if (cid) {
        // $.ajax({
        //     url: "/actions.php",
        //     method: "post",
        //     data: {
        //         action: "getcountryregions",
        //         country_id: cid
        //     },
        //     dataType: "json",
        //     complete: function (result) {
        //         $('.region-container.dropdown').unbind('click');
        //         var data = result.responseJSON;
        //         container.find('.region-container .dropdown-choices').html('<span data-value="0">-</span>');
        //         $.each(data, function (i, o) {
        //             container.find('.region-container .dropdown-choices').append('<span data-value="' + o.region_id + '">' + o.name + '</span>');
        //         });
        //         dropdown('.region-container');
        //         //
        //     }
        // });
    }
}

function changeAddress(container) {
    var addr = container;
    countrySelect.val(addr.data("cid"));
}

function parseBasketValues(result) {
    //SUMMARY
    $(".subTotalVal").text(result.subTotal);
    $(".vatVal").text(result.vat);
    $(".weight").text(result.weight);
    $(".shippingVal").text(result.shipping);
    $(".discountVal").text(result.discount);
    $(".totalVal, #sumTotal").text(result.total);

    if (parseFloat(result.discount.replace(",", ".")) != 0)
        $("#discountContainer").show();
    else if (parseFloat(result.shipping.replace(",", ".")) != 0) {
        //$("#discountContainer").hide();

        $(".freeShip").hide();
        $(".payShip").show();
    } else {
        $(".freeShip").show();
        $(".payShip").hide();
    }

    //HEADER
    $("#sumItems").text(result.total_items);
    $("#sumTotal").text(result.total_no_extras);

    //Cart
    if ($(".totalItems").length > 0) $(".totalItems").text(result.total_items);

    try {
        $(".nowFreeShipping").hide();
        $(".overLimitFreeShipping").hide();

        if (result.total_no_extras >= 60) {
            $(".nowFreeShipping").show();
        } else {
            $(".overLimitFreeShipping").show();
        }
    } catch (e) {}
}

/*
|--------------------------------------------------------------------------
| PRODUCT DETAILS
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
function initProduct() {
    $(".add-to-cart").click(function (e) {
        e.preventDefault();
        var selectedProduct = $("select.variant-filter option:selected");
        var variant = selectedProduct.data("variantid");
        var pageid = selectedProduct.data("productid");
        var price = selectedProduct.data("price");
        var code = selectedProduct.data("code");
        var isDisabled = selectedProduct.hasClass("disabled");
        $("select.variant-filter").removeClass("hasError");
        if (isDisabled) {
            if (!variant) {
                displayMessage("selectSize", true);
                $("select.variant-filter")
                    .focus()
                    .addClass("hasError");
            } else {
                $(".msg").fadeOut("fast");
                displayMessage("outOfStock", true);
            }
        } else {
            $(".add-to-cart").addClass('loading');
            // $.ajax({
            //     url: "/actions.php",
            //     data: {
            //         action: "additem",
            //         variant: variant,
            //         pageid: pageid
            //     },
            //     dataType: "json",
            //     success: function (result) {
            //         itemAdditionCallback(result);
            //         $(".add-to-cart").removeClass('loading');
            //     }
            // });
        }
    });

    $(".add-to-wishlist").click(function (e) {
        e.preventDefault();
        var selectedProduct = $("select.variant-filter option:selected");
        var variant = selectedProduct.data("variantid");
        var productid = selectedProduct.data("productid");
        var notification = $(this).data("notification");

        if (typeof variant == "undefined" || variant == "") {
            displayMessage("selectSize", true);
        } else {
            var jsonData = {
                action: "addtowishlist",
                variantid: variant,
                productid: productid
            };
            if (notification) {
                jsonData.notification = 1;
            }
            // $.ajax({
            //     url: "/actions.php",
            //     data: jsonData,
            //     dataType: "json",
            //     success: function (result) {
            //         if (notification && result.success >= 0) {
            //             displayTimedMessage("notifySuccess", 6000);
            //         } else {
            //             if (result.success > 0) {
            //                 displayTimedMessage("addedToWishlist", 6000);
            //             } else if (result.success == 0) {
            //                 displayTimedMessage("alreadyInWishlist", 6000);
            //             } else if (result.success == -1) {
            //                 displayTimedMessage("notLoggedIn", 6000);
            //             }
            //         }
            //     }
            // });
        }
    });
}


/*
|--------------------------------------------------------------------------
| CHECKOUT ORDER DETAILS - STEP 2
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
$(document).ready(function () {
    var syncItemsInterval = 1 * 60 * 60; //1 minute

    //setTimeout(syncCartItems(), syncItemsInterval);

    showLastItems();

});

function syncCartItems() {
    // setInterval(function () {
    //     $.ajax({
    //         url: '/actions.php?action=synchronize-cart',
    //         success: function (result) {
    //             if (result == 'changed') {
    //                 location.reload();
    //             }
    //         }
    //     });
    // }, syncItemsInterval);
}

function recalculateTotals(costName, add) {
    // $.ajax({
    //     url: 'actions.php',
    //     method: 'POST',
    //     data: {
    //         action: 'changeextracosts',
    //         costName: costName,
    //         add: add
    //     },
    //     dataType: 'json',
    //     success: function (result) {
    //         parseBasketValues(result);
    //         if (add) {
    //             $("#" + costName + "Container").fadeIn("fast");
    //         } else {
    //             $("#" + costName + "Container").fadeOut("fast");
    //         }

    //     }
    // });
}

function changeShipping() {
    // $.ajax({
    //     url: '/actions.php',
    //     method: 'POST',
    //     data: {
    //         action: 'change-shipping',
    //     },
    //     dataType: 'json',
    //     success: function (result) {
    //         parseBasketValues(result);

    //     }
    // });
}